import React from "react";
const HeaderTitle = React.memo(() => {
  return <h1 className="Header-title">君の名は？</h1>;
});
export default HeaderTitle;
